import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

type StylesProps = {
	qualityBackgroundColor: string
	statusBackgroundColor: string
}

const useStyles = makeStyles((theme) => ({
	header: {
		"&&": {
			padding: 0,
			alignItems: "center"
		}
	},
	name: {
		fontSize: "1rem",
		width: "23ch",
		fontWeight: 500,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	feedbackGrid: {
		display: "flex",
		gap: theme.spacing(1)
	},
	statusChip: (props: StylesProps) => ({
		...ColorUtil.getBackgroundAndContrastColor(props.statusBackgroundColor)
	}),
	qualityChip: (props: StylesProps) => ({
		...ColorUtil.getBackgroundAndContrastColor(props.qualityBackgroundColor)
	}),
	categoryChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
		borderRadius: 20,
		color: colors.purple[500],
		fontSize: 12,
		height: 30
	},
	footer: {
		justifyContent: "flex-end",
		padding: 0
	},
	content: {
		justifyContent: "center",
		alignitems: "center",
		height: 324,
		overflowY: "auto",
		padding: 10,
		borderRadius: 8,
		"&::-webkit-scrollbar": {
			width: "0.25em"
		},
		"&::-webkit-scrollbar-track": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
			borderRadius: "10px"
		},
		"&::-webkit-scrollbar-thumb": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200]),
			borderRadius: "10px",
			border: "2px solid transparent",
			backgroundClip: "content-box"
		}
	},
	moreOptionsButton: {
		padding: "8px 1px 0px 0px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		}
	},
	chipLabel: {
		display: "flex",
		alignItems: "center",
		gap: 4
	},
	iconStyle: {
		fontSize: 16,
		color: colors.gray[500]
	}
}))

export default useStyles
